import {endpointKeys, PractitionerIdParam} from '@common/api'
import {
  PractitionerWorkingHour,
  UpsertPractitionerWorkingHourRequest,
} from '@common/models'

import {useApi, useWebGet, useWebSet} from './helpers'

/**
 * Hooks for Practitioner Working Hours (Partner Admin scope)
 * Base path: /api/v1/partner-administrators/practitioners/{practitionerId}/working-hours
 */

export const useGetPractitionerWorkingHours = (params: PractitionerIdParam) =>
  useWebGet<PractitionerWorkingHour[]>(
    [endpointKeys.partnerAdminPractitionerWorkingHours, params],
    useApi().partnerAdminPractitionerWorkingHours(params),
    (data) => data,
  )

export const useCreatePractitionerWorkingHour = (params: PractitionerIdParam) =>
  useWebSet<UpsertPractitionerWorkingHourRequest, PractitionerWorkingHour>(
    [endpointKeys.partnerAdminPractitionerWorkingHours, params],
    useApi().partnerAdminPractitionerWorkingHours(params),
    'POST',
    (data) => data,
    [
      [endpointKeys.partnerAdminPractitionerWorkingHours, params],
      [endpointKeys.partnerAdminPractitionersWorkingHours],
      [endpointKeys.partnerAdminPractitioners],
      [endpointKeys.partnerAdminPractitionerAvailability],
      [
        endpointKeys.partnerAdminPractitionerAvailability,
        {practitionerId: params.practitionerId},
      ],
    ],
  )

export const useUpdatePractitionerWorkingHour = (
  params: PractitionerIdParam & {id: string},
) =>
  useWebSet<UpsertPractitionerWorkingHourRequest, PractitionerWorkingHour>(
    [endpointKeys.partnerAdminPractitionerWorkingHour, params],
    useApi().partnerAdminPractitionerWorkingHour(params),
    'PUT',
    (data) => data,
    [
      [endpointKeys.partnerAdminPractitionerWorkingHours, params],
      [endpointKeys.partnerAdminPractitionersWorkingHours],
      [endpointKeys.partnerAdminPractitioners],
      [endpointKeys.partnerAdminPractitionerAvailability],
      [
        endpointKeys.partnerAdminPractitionerAvailability,
        {practitionerId: params.practitionerId},
      ],
    ],
  )

export const useDeletePractitionerWorkingHour = (
  params: PractitionerIdParam & {id: string},
) =>
  useWebSet<void, void>(
    [endpointKeys.partnerAdminPractitionerWorkingHour, params],
    useApi().partnerAdminPractitionerWorkingHour(params),
    'DELETE',
    (data) => data,
    [
      [endpointKeys.partnerAdminPractitionerWorkingHours, params],
      [endpointKeys.partnerAdminPractitionersWorkingHours],
      [endpointKeys.partnerAdminPractitioners],
      [endpointKeys.partnerAdminPractitionerAvailability],
      [
        endpointKeys.partnerAdminPractitionerAvailability,
        {practitionerId: params.practitionerId},
      ],
    ],
  )
